// Farm View "Field details" strip order (after the crop water availability
// gauge). Metrics not listed here (soil temperature, fert tank, expiration)
// keep their relative order after these.
const FARM_VARIANT_METRIC_ORDER = [
  'Field_details_days_in_season',
  'gdd',
  'gdd_soil',
  'et0',
  'kc',
  'crop_type',
  'area',
  'irrigation_type',
  'soil_type',
];

const rank = (label) => {
  const index = FARM_VARIANT_METRIC_ORDER.indexOf(label);
  return index === -1 ? FARM_VARIANT_METRIC_ORDER.length : index;
};

// Drops metrics whose `condition` is falsy and orders the rest. The sort is
// stable, so unlisted metrics keep their incoming order.
const orderFarmMetrics = (metrics) =>
  metrics
    .filter((metric) => metric.condition)
    .sort((a, b) => rank(a.label) - rank(b.label));

module.exports = { FARM_VARIANT_METRIC_ORDER, orderFarmMetrics };
